module.exports = __webpack_public_path__ + "img/ep-baroque.e6d2760e.jpg";